export const RADIAL_GRADIENT = "radial-gradient(ellipse farthest-corner at 93% 5%, rgba(0,0,0,0) 0%, rgba(0,0,0,0.1) 20%, rgba(0,0,0,0.2) 30%, rgba(0,0,0,0.3) 40%, rgba(0,0,0,0.5) 50%, rgba(0,0,0,0.6) 60%, rgba(0,0,0,0.7) 70%, rgba(0,0,0,0.8) 90%, rgba(0,0,0,1) 100%)";
export const LINEAR_GRADIENT = "linear-gradient(0deg, #000 12%, rgba(0, 0, 0, 0.0) 80%)";
export const LINEAR_GRADIENT_TRIP_LIST_CARD = "linear-gradient(72.09deg, rgba(0, 0, 0, 0.4) 31.76%, rgba(102, 102, 102, 0.4) 52.36%)";
export const HOTEL_FALLBACK_IMAGE_HOME_TRIP_CARD = "images/onefront/bluestone/images/hotel-fallback-card-home.png";
export const getDestinationImagePath = cityIata => `/images/onefront/destinations/${cityIata}.jpg`;
export const getDefaultTripCardImagePath = () => {
  return `/images/onefront/bluestone/images/1_1_1x.png`;
};
export const getPromoAccommodationCardImagePath = brand => {
  return `/images/onefront/tripcard/${brand.name}/tripcard_${brand.abbreviation}.png`;
};
export const getBrandedImage = (image, brand = "ED", assetURL = "/images/onefront/bluestone") => {
  let imageBrand;
  switch (brand) {
    case "GO":
      imageBrand = "GV";
      break;
    case "TR":
      imageBrand = "TL";
      break;
    default:
      imageBrand = brand;
  }
  return `${assetURL}/${imageBrand}/${image}`;
};